export function useImageCropper () {
  // 创建临时 canvas 元素
  const createTempCanvas = () => {
    const canvas = document.createElement('canvas')
    canvas.style.display = 'none'
    document.body.appendChild(canvas)
    return canvas
  }

  // Blob 转 Base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  }

  const cropper = async (
    imgUrl,
    coordinates
  ) => {
    const canvas = createTempCanvas()
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Failed to get canvas context')

    try {
      // 获取并转换图像
      const response = await fetch(imgUrl)
      const blob = await response.blob()
      const base64Image = await blobToBase64(blob)

      // 加载图像
      const image = new Image()
      image.src = base64Image

      // 等待图像加载
      await new Promise((resolve, reject) => {
        image.onload = resolve
        image.onerror = reject
      })

      const result = []

      // 处理每个裁剪区域
      for (let index = 0; index < coordinates.length; index++) {
        const coord = coordinates[index]
        const width = coord[1] - coord[0]
        const height = coord[3] - coord[2]

        // 设置 canvas 尺寸
        canvas.width = width
        canvas.height = height

        // 清空并绘制裁剪区域
        ctx.clearRect(0, 0, width, height)
        ctx.drawImage(
          image,
          coord[0], coord[2], // 源图像裁剪起点
          width, height, // 源图像裁剪尺寸
          0, 0, // 目标画布起点
          width, height // 目标画布尺寸
        )

        // 保存结果
        result.push({
          imgUrl: canvas.toDataURL(),
          coordinate: coord
        })
      }

      return result
    } catch (error) {
      console.error('Image cropping failed:', error)
      throw error
    } finally {
      document.body.removeChild(canvas)
    }
  }

  return { cropper }
}
